import { useState } from 'react';
import { Outlet } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
//
import Login from '../../components/Auth';
import ModalStatusConexao from '../../components/ModalStatusConexao';

import ServerStatusView from '../../components/ServerStatusView';
import { useWSContext } from '../../context/WebSocketContext';
import AppNavBar from './AppNavBar';
import AppSideBar from './AppSideBar';

// import { WebSocket } from '../../components/WebSocket';

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  background: theme.palette.background.paper,
}));

function AppNavigation() {
  const [open, setOpen] = useState(false);

  const { login, serverStatus, isOnline, isLoggingIn } = useWSContext();

  const [screenLogin, setScreenLogin] = useState(true);

  function realizaLogin(user) {
    const { userLogin } = user;
    const { passwordLogin } = user;
    login(userLogin, passwordLogin);
  }

  return (
    <RootStyle>
      <ServerStatusView serverStatus={serverStatus} />
      <Login
        recebeLogin={(value) => realizaLogin(value)}
        openLogin={!isOnline}
        serverStatus={serverStatus}
        isLoggingIn={isLoggingIn}
      />
      <ModalStatusConexao />
      <AppNavBar onOpenSidebar={() => setOpen(true)} />
      <AppSideBar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
        userIsOnline={isOnline}
      />
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}

export default AppNavigation;
